/* eslint-disable no-unused-vars */
  import React from 'react'
  import GridLayout from './components/GridLayout';  
  import './style.css';

  const App = () => {
    return (
      <>
        <GridLayout/>
      </>
    )
  }
  
  export default App
  